/**
 * Route handler đăng xuất trọn gói phía server — xem `src/app/api/signout/route.ts`.
 * Tại đó: gọi BE kết thúc phiên SSO → xóa cookie session next-auth + id_token ngay trên
 * response → 302 tới end-session Keycloak hoặc /signin.
 */
export const API_SIGNOUT_ROUTE = '/api/signout';

/**
 * Đăng xuất bằng cách điều hướng cứng sang {@link API_SIGNOUT_ROUTE}.
 *
 * Trước đây hàm này tự chạy 3 bước tuần tự từ client (logout SSO → signOut next-auth →
 * điều hướng) với timeout từng bước; khi mạng chậm, bước sau điều hướng sẽ HỦY request
 * đang bay của bước trước → phiên Keycloak hoặc cookie session sống sót → với site bật
 * FORCE_SSO_LOGIN user bị auto đăng nhập lại ngay ("bấm đăng xuất không ăn").
 * Toàn bộ logic đó đã chuyển vào route /api/signout chạy server-side trong MỘT request,
 * nên không còn race và mọi nhánh lỗi đều ra đích an toàn.
 *
 * - `redirect !== false`: hàm tự điều hướng cứng (window.location.replace).
 * - `redirect === false`: hàm KHÔNG điều hướng, trả về `{ url }` để caller tự điều hướng.
 *   Caller PHẢI dùng full navigation (window.location.*), KHÔNG dùng router.push —
 *   route handler cần một browser navigation thật để Set-Cookie xóa session có hiệu lực.
 *
 * Query `from` = pathname hiện tại: để server phân vùng cờ FORCE_SSO_LOGIN khi hai site
 * dùng chung domain (APP_NAME rỗng).
 *
 * Hàm không bao giờ throw. Luôn trả về `{ url: string }`.
 */
export async function performSignOut(options?: {
    redirect?: boolean;
}): Promise<{ url: string }> {
    let url = API_SIGNOUT_ROUTE;

    if (typeof window !== 'undefined' && window.location.pathname) {
        url += `?from=${encodeURIComponent(window.location.pathname)}`;
    }

    if (options?.redirect !== false && typeof window !== 'undefined') {
        window.location.replace(url);
    }

    return { url };
}
